/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/useQaItpSaveToQDrive.ts
 * FILE_ID: JOBHUB-QA-ITP-SAVE-QDRIVE-001
 * PURPOSE: Save the current ITP PDF onto the job in qDrive.
 */
import { useState } from 'react'

export function useQaItpSaveToQDrive({
  upload,
  jobId,
  filename,
  bytes,
  setNotice,
  setError,
  onError,
}: {
  upload?: (file: File, jobId: number) => Promise<{ id: string }>
  jobId: number
  filename: () => string
  bytes: () => Promise<Blob>
  setNotice: (value: string | null) => void
  setError: (value: string | null) => void
  onError?: (err: unknown) => void
}) {
  const [savingCopy, setSavingCopy] = useState(false)
  const saveToQDrive = async () => {
    if (!upload || savingCopy) return
    setSavingCopy(true)
    setError(null)
    try {
      const name = filename()
      const blob = await bytes()
      await upload(new File([blob], name, { type: 'application/pdf' }), jobId)
      setNotice(`Saved to QDrive: ${name}`)
    } catch (err) {
      if (onError) onError(err)
      else setError(err instanceof Error ? err.message : 'Could not save to QDrive.')
    } finally {
      setSavingCopy(false)
    }
  }
  return { savingCopy, saveToQDrive }
}
